var ScopeDataFetchMixin;

ScopeDataFetchMixin = {
  _isFetchDisabled: function() {
    return this.props.readOnly || this.props.isFetchingResults;
  }
};

module.exports = ScopeDataFetchMixin;
